import JwtService from './jwtService'

export default function useJwt(API, jwtOverrideConfig) {
  const jwt = new JwtService(API, jwtOverrideConfig)

  return {
    jwt,
  }
}
